// Thin wrapper for every tab's scrollbox. Now that the tab bar and
// composer are transparent, tab content is constrained to the
// exposed region between them (top-14 tab bar height; caller
// provides bottom via `bottomOffset` for the chat composer).
// Native browser scrollbar — no custom thumb needed.

import { type ReactNode } from "react";

interface Props {
  children: ReactNode;
  testId?: string;
  /** Pixels reserved below the scroll region. Chat passes the
   * composer height; other tabs leave 0. */
  bottomOffset?: number;
}

const TAB_BAR_HEIGHT_PX = 56;

export function TabScrollbox({ children, testId, bottomOffset = 0 }: Props) {
  return (
    <div
      className="absolute left-0 right-0 overflow-y-auto px-4 pt-3 pb-8"
      style={{
        top: TAB_BAR_HEIGHT_PX,
        bottom: bottomOffset,
      }}
      data-testid={testId}
    >
      {children}
    </div>
  );
}
